import { useParams } from 'react-router-dom'

import { GetMeetingDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import NotFound from 'modules/core/components/NotFound'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

// eslint-disable-line
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import TalkingPoints from 'modules/one_on_ones/components/TalkingPoints'
import TaskSection from 'modules/one_on_ones/components/TaskSection'

export const OldMeetingShowPage = () => {
  const { employee } = useCurrentSession()
  const param = useParams()

  const { data, loading, error } = useQuery(GetMeetingDocument, {
    variables: { id: Number(param.id || param.meetingId) },
  })
  const meeting = data?.oneOnOnes.meeting

  if (loading) {
    return <Loading />
  }

  if (
    !meeting ||
    !employee ||
    !meeting.oneOnOne.firstParticipant ||
    !meeting.oneOnOne.secondParticipant
  )
    return <NotFound />

  const isParticipant =
    meeting.oneOnOne.firstParticipant.id === employee.id ||
    meeting.oneOnOne.secondParticipant.id === employee.id

  const firstParticipant = meeting.oneOnOne.firstParticipant
  const secondParticipant = meeting.oneOnOne.secondParticipant

  let firstDisplayParticipant
  let secondDisplayParticipant

  // If the second participant is current employee, we need to swap the participants to display the current employee's talking points first
  if (secondParticipant.id === employee.id) {
    firstDisplayParticipant = secondParticipant
    secondDisplayParticipant = firstParticipant
  } else {
    firstDisplayParticipant = firstParticipant
    secondDisplayParticipant = secondParticipant
  }

  const firstDisplayParticipantTalkingPoint = meeting.talkingPointsConnection.nodes?.find(
    (talkingPoint) => talkingPoint?.owner.id === firstDisplayParticipant.id
  )
  const secondDisplayParticipantTalkingPoint = meeting.talkingPointsConnection.nodes?.find(
    (talkingPoint) => talkingPoint?.owner.id === secondDisplayParticipant.id
  )

  return (
    <ResponsivePage.Body loading={loading} error={error}>
      {/* First participant display */}
      <TalkingPoints
        talkingPoint={firstDisplayParticipantTalkingPoint}
        meetingId={meeting.id}
        participant={firstDisplayParticipant}
        readOnly={firstDisplayParticipant.id !== employee.id}
        displayBorders={false}
      />
      {/* Second participant display */}
      <TalkingPoints
        talkingPoint={secondDisplayParticipantTalkingPoint}
        meetingId={meeting.id}
        participant={secondDisplayParticipant}
        readOnly={secondDisplayParticipant.id !== employee.id}
      />
      <TaskSection
        meetingId={meeting.id}
        participantIds={[
          meeting.oneOnOne.firstParticipant.id,
          meeting.oneOnOne.secondParticipant.id,
        ]}
        canAddTask={isParticipant}
      />
    </ResponsivePage.Body>
  )
}
